import Icon, { IconNames } from "../../../../Foundation/Icons";
import { IconColours } from "../../../../Foundation/Icons/interface";
import { BaseCardProps } from "../../interface";
import classes from "./textWithLinkAndIcon.module.scss";

const TextWithLinkAndIcon = ({ item }: BaseCardProps) => {
    const { title } = item;
    return (
        <div className={classes.icon_card}>
            <div>
                <span className={classes.label_wrap}>{title}</span>
                <Icon
                    name={IconNames.Arrow}
                    colour={IconColours.white}
                    ariaHidden={true}
                ></Icon>
            </div>
        </div>
    );
};

export default TextWithLinkAndIcon;
